module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp12_5012.23e3fad7.png";